export default __webpack_public_path__ + "static/media/upload_photo.c61fe8d4.svg";